// src/api/news.js
import request from '../helper/request'

// 获取新闻列表（POST 方式）
export function getNewsList(params) {
  return request({
    url: "/api/getNewsList/",
    method: "post",
    data: params   // 这里要用 data 而不是 params
  })
}

// 新增新闻
export function addNews(data) {
  return request({
    url: "/api/addNews/",
    method: "post",
    data
  })
}

// 更新新闻
export function updateNews(data) {
  return request({
    url: "/api/updateNews/",
    method: "post",
    data
  })
}

// 删除新闻
export function deleteNews(data) {
  return request({
    url: "/api/deleteNews/",
    method: "post",
    data
  })
}


/**
 * 获取最新新闻
 * @param {String} category - 'company', 'industry', 'faq'
 * @returns {Promise}
 */
export function getLastNews(category = "company") {
  return request({
    url: "/api/getLastNews/",
    method: "post",
    data: { category }
  });
}
